import { useNavigate } from "@tanstack/react-router";

export function PublicVerdictFooter() {
  const navigate = useNavigate();

  return (
    <footer
      data-rp="public-verdict-footer"
      style={{
        background: "var(--charcoal)",
        padding: "36px 24px",
        textAlign: "center",
        marginTop: 56,
      }}
    >
      <div
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: 10,
          color: "var(--ivory)",
          letterSpacing: "3px",
          textTransform: "uppercase",
          marginBottom: 24,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <span>Rendu par</span>
        <span
          style={{
            fontFamily: '"Fraunces", serif',
            fontWeight: 900,
            fontSize: 22,
            color: "var(--ivory)",
            letterSpacing: 0,
            textTransform: "none",
            display: "inline-flex",
            alignItems: "baseline",
            gap: 3,
          }}
        >
          Hōjin
          <span
            aria-hidden
            style={{
              width: 5,
              height: 5,
              background: "var(--terracotta)",
              display: "inline-block",
            }}
          />
        </span>
        <span>· Volume MMXXVI</span>
      </div>
      <div>
        <button
          type="button"
          onClick={() => navigate({ to: "/signup" })}
          style={{
            background: "var(--accent-cramoisi)",
            color: "var(--charcoal)",
            border: "none",
            padding: "14px 28px",
            fontFamily: '"DM Mono", monospace',
            fontSize: 11,
            letterSpacing: "2px",
            textTransform: "uppercase",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Saisir Hōjin à votre tour →
        </button>
      </div>
    </footer>
  );
}
